<div class="tab-bar">
  <perfect-scrollbar class="tab-bar__ps" [config]="{ suppressScrollY: true }">
    <ul class="tab-bar__list">
      <li *ngFor="let link of links; trackBy: trackByPathOrFragment" class="tab-bar__item">
        <a
          *ngIf="link.fragment && link.fragment !== ''"
          [routerLink]="link.path"
          [fragment]="link.fragment || ''"
          class="tab-bar__link"
          [class.tab-bar__link--active]="activeFragment === link.fragment"
          queryParamsHandling="merge"
          appEventTracker
          [eventCategory]="link.event?.eventCategory"
          [eventAction]="link.event?.eventAction"
          [eventLabel]="link.event?.eventLabel"
          [eventValue]="link.event?.eventValue"
        >
          {{ link.label }}
          <app-badge
            *ngIf="link.notificationContent"
            class="tab-bar__badge"
            [theme]="BadgeThemeEnum.WhiteOnBlack"
            [content]="link.notificationContent"
          ></app-badge>
        </a>

        <a
          *ngIf="(!link.fragment || link.fragment === '') && link.exact"
          [routerLink]="link.path"
          class="tab-bar__link"
          [class.tab-bar__link--active]="isActiveExact(link.path)"
          queryParamsHandling="merge"
          appEventTracker
          [eventCategory]="link.event?.eventCategory"
          [eventAction]="link.event?.eventAction"
          [eventLabel]="link.event?.eventLabel"
          [eventValue]="link.event?.eventValue"
        >
          {{ link.label }}
          <app-badge
            *ngIf="link.notificationContent"
            class="tab-bar__badge"
            [theme]="BadgeThemeEnum.WhiteOnBlack"
            [content]="link.notificationContent"
          ></app-badge>
        </a>

        <a
          *ngIf="(!link.fragment || link.fragment === '') && !link.exact"
          [routerLink]="link.path"
          class="tab-bar__link"
          routerLinkActive="tab-bar__link--active"
          [routerLinkActiveOptions]="{ exact: true }"
          queryParamsHandling="merge"
          appEventTracker
          [eventCategory]="link.event?.eventCategory"
          [eventAction]="link.event?.eventAction"
          [eventLabel]="link.event?.eventLabel"
          [eventValue]="link.event?.eventValue"
        >
          {{ link.label }}
          <app-badge
            *ngIf="link.notificationContent"
            class="tab-bar__badge"
            [theme]="BadgeThemeEnum.WhiteOnBlack"
            [content]="link.notificationContent"
          ></app-badge>
        </a>
      </li>
    </ul>
  </perfect-scrollbar>
</div>
